export default __webpack_public_path__ + "static/media/iconDispositivos.55b830c2.svg";